import { render, staticRenderFns } from "./listVendas.vue?vue&type=template&id=5fe8412d"
import script from "./listVendas.ts?vue&type=script&lang=js&external"
export * from "./listVendas.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fe8412d')) {
      api.createRecord('5fe8412d', component.options)
    } else {
      api.reload('5fe8412d', component.options)
    }
    module.hot.accept("./listVendas.vue?vue&type=template&id=5fe8412d", function () {
      api.rerender('5fe8412d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/contareceber/listVendas.vue"
export default component.exports